import { SidebarTrigger } from './ui/sidebar';
import { NotificationHeader } from './notifications/notification-header';


export function TopBar() {
  return (
    <header className="sticky top-0 z-40 w-full backdrop-blur-xl border-none bg-background/80 transition-all duration-300 relative">
      <div className="absolute bottom-0 right-0 h-[2px] w-1/1 bg-gradient-to-l from-gray-600 to-transparent"></div>
      <div className="h-16 px-4 md:px-8 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <SidebarTrigger className="h-10 w-10 hover:bg-muted transition-colors rounded-xl md:hidden" />
          <div className="hidden md:block">
            {/* Optional: Add breadcrumbs or page title here */}
          </div>
        </div>

        <div className="flex items-center gap-4">
          <NotificationHeader />

        </div>
      </div>
    </header>
  );
}
